import './app/polyfills/globalThis';
import './app/polyfills/objectEntries';
import './app/polyfills/abort-controller';
import './app/promise-polyfill';
// Fetch API (fetch/Request/Response/Headers) — absent on old engines like webOS
// Chrome 38; react-router references Request and the app uses fetch() directly.
import 'whatwg-fetch';

import('./bootstrap');

export {};
